"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateOrders = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const StateOrder_1 = require("./StateOrder");
class StateOrders extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Orders", true);
        this._filterMode = "active";
        this._currentPage = 0;
        this._loadedOrders = [];
        this._filteredOrders = [];
        this._hasMore = true;
        this._nextSkip = 0;
        this._isLoading = false;
        this.page.ctrls.blockSearch.hide();
        this.page.ctrls.blockFilters.show();
        this.page.ctrls.blockPagination.hide();
        this.page.ctrls.btnPrevPage.onclick = () => this._changePage(-1);
        this.page.ctrls.btnNextPage.onclick = () => this._changePage(1);
        this.page.ctrls.btnNew.hide();
        this._setupFilterUi();
        const filterEl = this._getFilterElement();
        if (filterEl)
            filterEl.onchange = () => this._handleFilterChange();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if ((args === null || args === void 0 ? void 0 : args.filter) && this._isFilterValue(args.filter)) {
                this._filterMode = args.filter;
                this._setFilterSelection();
            }
            yield this._reloadFromStart();
            this._syncUrlFilter();
            return _super.start.call(this, args);
        });
    }
    _reloadFromStart() {
        return __awaiter(this, void 0, void 0, function* () {
            this._resetState();
            this.page.ctrls.list.html = "";
            yield this._ensurePageData(0);
            this._currentPage = 0;
            this._renderCurrentPage();
        });
    }
    _resetState() {
        this._loadedOrders = [];
        this._filteredOrders = [];
        this._hasMore = true;
        this._nextSkip = 0;
        this._isLoading = false;
        this._currentPage = 0;
        this.page.ctrls.blockPagination.hide();
    }
    _ensurePageData(pageIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const requiredItems = (pageIndex + 1) * StateOrders.PageSize;
            while (this._filteredOrders.length < requiredItems && this._hasMore) {
                yield this._loadNextChunk();
            }
        });
    }
    _loadNextChunk() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._isLoading || !this._hasMore)
                return;
            this._isLoading = true;
            const take = StateOrders.FetchSize;
            const result = yield this.lockgui(this.app.api.admin.activeManager.byQuery(0, 0, this._nextSkip, take, 0, 0, false, false, 0));
            this._isLoading = false;
            if (!Array.isArray(result) || result.length === 0) {
                this._hasMore = false;
                return;
            }
            this._nextSkip += result.length;
            if (result.length < take)
                this._hasMore = false;
            this._loadedOrders.push(...result);
            this._applyFilter();
        });
    }
    _applyFilter() {
        const filtered = this._loadedOrders.filter((wrapper) => {
            const order = wrapper.order;
            const isCancelled = this._isCancelledOrDeleted(order);
            switch (this._filterMode) {
                case "active":
                    return !isCancelled;
                case "cancelled":
                    return isCancelled;
                default:
                    return true;
            }
        });
        filtered.sort((a, b) => this._getCreatedTimestamp(b.order) - this._getCreatedTimestamp(a.order));
        this._filteredOrders = filtered;
    }
    _setupFilterUi() {
        if (this.page.ctrls.labelFilter)
            this.page.ctrls.labelFilter.text = "Status filter";
        const select = this._getFilterElement();
        if (!select)
            return;
        select.innerHTML = "";
        select.append(new Option("Actuale orders", "active"));
        select.append(new Option("All orders", "all"));
        select.append(new Option("Cancelled & deleted", "cancelled"));
        select.value = this._filterMode;
    }
    _renderCurrentPage() {
        const start = this._currentPage * StateOrders.PageSize;
        const items = this._filteredOrders.slice(start, start + StateOrders.PageSize);
        this._renderList(items);
        this._updatePager();
    }
    _renderList(orderWrappers) {
        this.page.ctrls.list.html = "";
        this.page.ctrls.btnNew.hide();
        for (const wrapper of orderWrappers) {
            const order = wrapper.order;
            const item = new com.ListItem();
            item.ctrls.lType.text = "Order";
            item.ctrls.lId.text = `#${order.id}`;
            const fromLocation = order.route.locations[0];
            const toLocation = order.route.locations[order.route.locations.length - 1];
            const lines = [
                gs.text.clearHtmlToText(`State: ${order.state}`),
                gs.text.clearHtmlToText(`From: ${fromLocation.addressFull}`),
                gs.text.clearHtmlToText(`To: ${toLocation.addressFull}`),
                gs.text.clearHtmlToText(`Departure time: ${gs.date.getShortTime(order.route.departureTime)}`),
            ];
            if (!order.finalPrice)
                lines.push(gs.text.clearHtmlToText(`Est.price: ${order.estimatedPrice}`));
            else
                lines.push(gs.text.clearHtmlToText(`Final price: ${order.finalPrice}`));
            item.ctrls.pData.html = lines.join("<br>");
            this.page.ctrls.list.append(item);
            item.onclick = () => gs_1.StateGS.Run(StateOrder_1.StateOrder, { id: order.id });
        }
        if (orderWrappers.length === 0) {
            const placeholder = gs.w(gs.html.tag("div", { class: "list-empty" }, "No orders found"));
            this.page.ctrls.list.append(placeholder);
        }
    }
    _updatePager() {
        const totalFiltered = this._filteredOrders.length;
        const shouldShowPager = totalFiltered > 0 || this._hasMore;
        if (!shouldShowPager) {
            this.page.ctrls.blockPagination.hide();
            return;
        }
        const totalPages = Math.max(1, Math.ceil(Math.max(totalFiltered, 1) / StateOrders.PageSize));
        const currentPageIndex = totalFiltered === 0 ? 0 : this._currentPage + 1;
        this.page.ctrls.blockPagination.show();
        this.page.ctrls.lPageInfo.text =
            totalFiltered === 0
                ? this._hasMore
                    ? "Searching for orders..."
                    : "No orders"
                : `Page ${currentPageIndex} of ${totalPages}`;
        if (this._currentPage === 0 || totalFiltered === 0)
            this.page.ctrls.btnPrevPage.disable();
        else
            this.page.ctrls.btnPrevPage.enable();
        const hasNext = (this._currentPage + 1) * StateOrders.PageSize < totalFiltered ||
            this._hasMore;
        if (!hasNext)
            this.page.ctrls.btnNextPage.disable();
        else
            this.page.ctrls.btnNextPage.enable();
    }
    _changePage(offset) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!offset)
                return;
            const targetPage = this._currentPage + offset;
            if (targetPage < 0)
                return;
            yield this._ensurePageData(targetPage);
            const totalPages = Math.max(1, Math.ceil(this._filteredOrders.length / StateOrders.PageSize));
            if (targetPage >= totalPages) {
                this._updatePager();
                return;
            }
            this._currentPage = targetPage;
            this._renderCurrentPage();
        });
    }
    _handleFilterChange() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const filterEl = this._getFilterElement();
            const value = ((_a = filterEl === null || filterEl === void 0 ? void 0 : filterEl.value) !== null && _a !== void 0 ? _a : "active");
            if (!this._isFilterValue(value)) {
                if (filterEl)
                    filterEl.value = this._filterMode;
                return;
            }
            if (value === this._filterMode)
                return;
            this._filterMode = value;
            yield this._reloadFromStart();
            this._setFilterSelection();
            this._syncUrlFilter();
        });
    }
    _isFilterValue(value) {
        return value === "active" || value === "all" || value === "cancelled";
    }
    _syncUrlFilter() {
        if (this._filterMode !== "active")
            this._urlArgs["filter"] = this._filterMode;
        else
            delete this._urlArgs["filter"];
        this.updateUrl();
    }
    _getFilterElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectFilter) === null || _a === void 0 ? void 0 : _a.el;
        if (element instanceof HTMLSelectElement)
            return element;
        return null;
    }
    _setFilterSelection() {
        const select = this._getFilterElement();
        if (select)
            select.value = this._filterMode;
    }
    _isCancelledOrDeleted(order) {
        var _a;
        const state = ((_a = order.state) !== null && _a !== void 0 ? _a : "").toLowerCase();
        if (state.includes("cancel"))
            return true;
        if (state.includes("delete"))
            return true;
        if (state.includes("removed"))
            return true;
        return false;
    }
    _getCreatedTimestamp(order) {
        const created = order === null || order === void 0 ? void 0 : order.created;
        if (!created)
            return 0;
        if (created instanceof Date)
            return created.getTime();
        const timestamp = new Date(created).getTime();
        return Number.isNaN(timestamp) ? 0 : timestamp;
    }
}
exports.StateOrders = StateOrders;
StateOrders.StateName = "orders";
StateOrders.PageSize = 20;
StateOrders.FetchSize = 50;
//# sourceMappingURL=StateOrders.js.map